// eslint-disable-next-line complexity
const deserializePractitionerActivity = apiActivity => ({
  hoursWorked: apiActivity.worked_hours ?? '',
  missedAppointments: apiActivity.missed_appointments ?? '',
  newPatients: apiActivity.new_patients ?? '',
  treatmentPlansProposed: apiActivity.proposed_treatment_plans ?? '',
  crownsPlaced: apiActivity.placed_crowns ?? '',
  activeOrthoPatients: apiActivity.active_ortho_patients ?? '',
  scheduledAppointments: apiActivity.scheduled_appointments ?? '',
  patientsTreated: apiActivity.treated_patients ?? '',
  emergencies: apiActivity.emergency_count ?? '',
  treatmentPlansAccepted: apiActivity.accepted_treatment_plans ?? '',
  implantsPlaced: apiActivity.placed_implants ?? '',
  revenue: apiActivity.revenue ?? ''
});

export default deserializePractitionerActivity;
